import { useHistory, useLocation } from "react-router-dom"

const saveScrollOffset = (
    history: ReturnType<typeof useHistory>,
    location: ReturnType<typeof useLocation<object>>,
) => {
    try {
        const scrollContainer = document.querySelectorAll(".app-scroll-view__inner")[0]
        const currentState = location.state
        const replaced = {
            pathname: location.pathname,
            state: { ...currentState, prevScrollTop: scrollContainer.scrollTop },
        }
        history.replace(replaced)
    } catch (error) {
        // nothing to do here
    }
}

export default saveScrollOffset
